<template>
  <header class="drawer-filters__container">
    <div class="drawer-filters__filters">
      <HSelect
        v-if="!searchOnly"
        :value="currentSortBy"
        class="drawer-filters__select"
        data-cy="sort-channels"
        :options="sortByOptions"
        option-key="type"
        option-label="label"
        @update:value="onSortChange"
      />

      <slot />

      <HFilterButton
        v-if="allowFilter"
        hide-counter
        :filter-counter-value="
          currentFilters.tags.length + currentFilters.status.length
        "
        :tooltip-position="allowSearch ? 'left' : 'right'"
        @toggle-filter="openFilters"
      />
    </div>

    <SearchPersons
      v-if="showSearchBox"
      ref="searchPerson"
      size="small"
      class="drawer-filters__search"
      placeholder="Buscar por membro"
      :person-id="currentFilters.personId"
      :autofocus="false"
      @select="onSearchSelect"
    />
  </header>
</template>

<script>
import { mapState } from 'vuex'

import { HSelect } from '@/components/shared/atoms'
import { HFilterButton } from '@/components/shared/atoms/filter'
import { SearchPersons } from '@/components/shared/molecules'
import { sortByMap } from '@/models/channels'

export default {
  components: {
    HFilterButton,
    SearchPersons,
    HSelect
  },
  props: {
    searchOnly: Boolean,
    allowSearch: Boolean,
    allowFilter: Boolean
  },
  emits: ['filter:change', 'sort:change'],
  data() {
    return {
      sortByOptions: sortByMap
    }
  },
  computed: {
    ...mapState('channel/drawer', ['currentFilters', 'currentSortBy']),
    showSearchBox() {
      return this.allowSearch || this.searchOnly
    }
  },
  methods: {
    onSearchSelect({ id: personId, channelPersonId } = {}) {
      this.$store.commit('channel/drawer/setCurrentFilters', {
        personId,
        channelPersonId
      })
      this.$emit('filter:change')
    },
    onSortChange(value) {
      this.setSortBy(value)
      this.$emit('sort:change')
    },
    setSortBy(value) {
      this.$store.commit('channel/drawer/setCurrentSortBy', value)
    },
    openFilters() {
      this.$store.commit('ui/channel/setFilters', true)
    }
  }
}
</script>

<style lang="scss">
.drawer-filters {
  &__container {
    background: var(--sys-color-surface-background-default);
    padding: var(--gl-spacing-04) 0;
    position: sticky;
    top: 54px;
    z-index: 1;
  }

  &__filters {
    display: flex;
    gap: var(--gl-spacing-02);
  }

  &__select {
    max-width: 256px;
  }

  &__search {
    margin-top: var(--gl-spacing-02);
  }
}
</style>
